(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterGridSelectDataitem', rmsListFilterGridSelectDataitem);

    function rmsListFilterGridSelectDataitem() {
        return {
            restrict: 'E',
            controller: rmsListFilterGridSelectDataitemCtrl,
            scope: {
                dataItem: '='
            },
            controllerAs: 'vm',
            bindToController: true,
            template: ''
        };
    }

    function rmsListFilterGridSelectDataitemCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;

            vm.pageData = {};

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }
    }
})();